/**
 *
 * @param allModalList
 * @param {object} data -
 *  @prop {boolean} data.modalIsLock -
 *  @prop {boolean} data.noModalAnimation -
 * @return {*|boolean|{modalIsLock: boolean, noModalAnimation: boolean, modalList: []}|{computed: {maskShow(): *}, data(): {modalIsLock: boolean, noModalAnimation: boolean, modalList: []}, methods: {modalCloseAll(string): void, modalIsOpen(string): boolean, modalHandler(string, *): void, modalOpen(string, boolean=): void, modalSwitch(string, string): void, modalClose(string): void}}}
 */
const modalMixin = (allModalList, data = {
  // 锁定弹窗，如果为 true 将不能接受新的弹窗压入弹窗栈
  modalIsLock: false,
  // 是否展示弹窗动画
  noModalAnimation: false,
}, ) => {
  const modalsSet = {};
  
  allModalList.forEach((name) => {
    modalsSet[name] = false;
  });
  
  const mixin = {
    computed: {
      /**
       * 是否展示
       */
      maskShow() {
        return allModalList.some(item => this[item] === true);
      }
    },
    methods: {
      /**
       * 关闭窗口
       * @param {string} name - 需要关闭的弹窗名字
       */
      modalClose(name) {
        if (this[name] !== undefined) {
          // 删除当前的一个
          const index = this.modalList.indexOf(name);
          if (index > -1) {
            this.modalList.splice(index, 1);
            if (!this.modalIsLock) {
              // 将余下的展示
              if (this.modalList.length) {
                const nextName = this.modalList[0];
                
                if (this[nextName] !== undefined) {
                  this[nextName] = true;
                }
              }
            }
            this[name] = false;
          }
        }
      },
      /**
       * 打开窗口
       * @param {string} name  - 需要打开的弹窗名
       * @param {boolean} [prepend=false] - 是否需要前置插入
       */
      modalOpen(name, prepend = false) {
        if (this[name] !== undefined) {
          if (prepend === false) {
            this.modalList.push(name);
            if (!this.maskShow) {
              this[name] = true;
            }
          } else {
            // 存在现有的弹窗需要吧当前第一个展示的先关闭掉
            const first = this.modalList[0];
            if (this[first]) {
              this.noModalAnimation = true;
              this[first] = false;
            }
            this.modalList.unshift(name);
            this[name] = true;
            this.$nextTick(() => {
              this.noModalAnimation = false;
            });
          }
        }
      },
      /**
       * 检查当前是否有窗口正在打开
       * @param name {string} - Modal名称
       * @return {boolean} - 是否有窗口正在打开
       */
      modalIsOpen(name) {
        return this.modalList.indexOf(name) > -1;
      },
      /**
       * 删除所有 Modal
       * @param name {string} - Modal 名称
       */
      modalCloseAll(name) {
        allModalList.forEach((target) => {
          if (this[target] !== undefined) {
            this[target] = false;
          }
        });
        
        this.modalList = [];
        
        if (name) {
          this.modalOpen(name);
        }
      },
      /**
       * 切换弹窗
       * @param close {string} - 关闭的弹窗名字
       * @param open {string} - 打开的弹窗名字
       */
      modalSwitch(close, open) {
        this.modalClose(close);
        this.modalOpen(open);
      },
      /**
       * 弹窗集中事件处理
       * @todo 这里可以执行扩展
       * @param type {string} - 接收的自定义事件名称
       * @param data {any} - 自定义传入的数据
       */
      modalHandler(type, data) {
        console.log(type, data);
        switch (type) {
          case 'modalClose':
            this.modalClose(data);
            break;
          case 'modalOpen':
            this.modalOpen(data);
            break;
          case 'modalSwitch':
            this.modalSwitch(data.close, data.open)
            break;
          //  这里可以拓展新的方法
          default:
            break;
        }
      },
    },
    data() {
      return {
        // 所有弹窗索引
        ...modalsSet,
        // 弹窗队列
        modalList: [],
        // 添加控制数据
        ...data,
      };
    },
  };
  
  return mixin;
};

export default modalMixin;

